import type { UseElementHoverOptions } from "@vueuse/core";

const useDebounceHover = (
  el: MaybeRefOrGetter<EventTarget | null | undefined>,
  onHover: () => void,
  options?: UseElementHoverOptions,
) => {
  const isHovered = useElementHover(el, options);

  watchEffect(() => {
    if (isHovered.value) {
      onHover();
    }
  });

  return isHovered;
};

export default useDebounceHover;
